import styled from 'styled-components';

export const SingleDateCalendarRoot = styled.div`
  display: flex;
  flex-direction: column;
`;
